import api from './api'
import { toastError } from './toast'
import { handleError } from './handle-error'

export const indexBudget = async () => {
  const result = new Promise((resolve, reject) => {
    api.get(`budgets`)
      .then(result => {
        resolve(result.data)
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      });
  })
  return result
}

export const indexBudgetResume = async params => {
  const result = new Promise((resolve, reject) => {
    api.get(`dashboard/budget`, { params: params })
      .then(result => {
        resolve(result.data)
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      });
  })
  return result
}